import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("nexus_token");
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("nexus_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("nexus_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const signup = async ({ name, email, password, confirm_password, company_name }) => {
    const { data } = await api.post("/auth/signup", { name, email, password, confirm_password, company_name });
    localStorage.setItem("nexus_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("nexus_token");
    setUser(null);
  };

  const switchTenant = async (tenantId) => {
    const { data } = await api.post(`/tenant/switch/${tenantId}`);
    localStorage.setItem("nexus_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const isAdmin = user?.membership_role === "COMPANY_ADMIN";
  const isSuperAdmin = user?.global_role === "SUPER_ADMIN";

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout, switchTenant, isAdmin, isSuperAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
